import baseFilterMutations from '../base_filter_mutations';

export default {
    ...baseFilterMutations,

    updateMeta(state, payload) {
        Object.assign(state.meta, payload.meta);
    },

    updateFilters(state, payload) {
        state.params = Object.assign({}, state.params, payload);
    },

    updateSearch(state, payload) {
        state.params.search = payload;
    },

    updateOrder(state, payload) {
        state.params.sort = payload;
    },

    updatePage(state, payload) {
        state.params.page = payload;
    }
}